import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoadingService } from '../services/loading/loading.service';
import { AuthService } from '../services/auth/auth.service';

@Component({
  selector: 'app-otp-code',
  templateUrl: './otp-code.component.html',
  styleUrls: ['./otp-code.component.css'],
})
export class OtpCodeComponent implements OnInit, OnDestroy {
  otpArray: string[] = Array(6).fill('');
  otpValues: string[] = [];
  email: string = '';
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';

  timeLeft: number = 600; // 10 minutes in seconds
  timerInterval: any;
  canResend: boolean = false;
  googleIcon = './assets/' + environment.projectName + '/icons/google.svg';
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private loader: LoadingService
  ) {}

  ngOnInit(): void {
    // ✅ Read lang from route params
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });

    // ✅ Read email and otp from QUERY PARAMS
    this.route.queryParams.subscribe((queryParams) => {
      const email = queryParams['email'];
      const otp = queryParams['otp'];

      if (email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
          alert('Please enter a valid email address');
          return;
        }
        this.email = email;
      }

      if (otp) {
        const otpPattern = /^[0-9]{6}$/;
        if (!otpPattern.test(otp)) {
          alert('Please enter a valid OTP');
          return;
        }
        this.updateOtp(otp);
      }
    });

    this.startTimer();
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  // ✅ Start 10-minute countdown
  startTimer(): void {
    this.timeLeft = 600;
    this.canResend = false;
    this.clearTimer();

    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.canResend = true;
        this.clearTimer();
      }
    }, 1000);
  }

  clearTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  // ✅ Format seconds → MM:SS
  get formattedTime(): string {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  updateOtp(otp: string) {
    this.otpValues = otp.split('');
    this.otpArray = this.otpValues.map((value) => (value ? value : ''));
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 1) {
      input.value = input.value.slice(0, 1);
    }

    const inputs = document.querySelectorAll('.otp-input');
    if (input.value.length === 1 && index < this.otpArray.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    } else if (index === this.otpArray.length - 1) {
      input.blur();
    }

    if (input.value.length === 0 && index > 0) {
      (inputs[index - 1] as HTMLInputElement).focus();
    }
  }

  verifyOtp() {
    this.loader.showLoading();
    this.authService.verifyOtp(this.email, this.otpValues.join('')).subscribe({
      next: (response: any) => {
        this.loader.hideLoading();
        // ✅ Fixed navigation bug (was a string literal before)
        this.router.navigate(['/' + this.lang + '/resetPassword'], {
          state: { email: this.email },
        });
      },
      error: (error) => {
        this.loader.hideLoading();
      },
    });
  }

  forgotPassword() {
    if (!this.canResend) return; // ✅ Block resend if timer still running

    this.loader.showLoading();
    this.authService.forgotPassword(this.email).subscribe({
      next: (response: any) => {
        this.loader.hideLoading();
        alert('OTP has been sent to your email');
        this.startTimer(); 
      },
      error: (error) => {
        this.loader.hideLoading();
      },
    });
  }
}